/** Display mode (no onRate) or interactive input (pass onRate). */
export default function StarRating({ value = 0, onRate, size }) {
  const rounded = Math.round(value);
  return (
    <span className="stars" style={size ? { fontSize: size } : undefined}>
      {[1, 2, 3, 4, 5].map((n) =>
        onRate ? (
          <button
            key={n}
            type="button"
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
            className={n <= value ? '' : 'off'}
            onClick={() => onRate(n)}
          >
            {n <= value ? '★' : '☆'}
          </button>
        ) : (
          <span key={n} className={n <= rounded ? '' : 'off'}>
            {n <= rounded ? '★' : '☆'}
          </span>
        )
      )}
    </span>
  );
}
